const routes = [
    { 
      path: 'send/', 
      name: 'QuotationSendHome',
      meta: { 
        title: 'Send Quotations',
        showQuotationsModal: true,
        modalType: 'send'
      },
      children: [
        { 
          path: ':quotationId', 
          name: 'QuotationSend',
          meta: { 
            title: 'Send Quotations',
            showQuotationsModal: true,
            modalType: 'send'
          }
        },
        { 
          path: ':quotationId/:emailMessageId', 
          name: 'QuotationSend',
          meta: { 
            title: 'Send Quotations',
            showQuotationsModal: true,
            modalType: 'send'
          }
        },
      ]
    },
  ] 
  
  export default routes;
  